<template>
  <div class="soll_warp">
    <div class="scrole">
      <!-- <el-input placeholder="请输入内容" v-model="input3">
        <el-button slot="append" icon="el-icon-search"></el-button>
      </el-input>-->
      <el-button
        type="primary"
        icon="el-icon-edit"
        style="margin-left: 30px; padding: 8px 20px !important"
        @click="addClick"
        >{{ dataobjs.xinzeng }}</el-button
      >
    </div>
    <div class="tablesList">
      <el-table
        :data="tableData"
        v-loading="Delectloading"
        height="100%"
        :element-loading-text="textContent"
        border
        :row-class-name="tableRowClassName"
        :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
      >
        <el-table-column
          prop="unittype"
          :label="dataobjs.chuangandanyuanleixing"
          width="130"
        ></el-table-column>
        <el-table-column
          prop="unittype_en"
          :label="dataobjs.chuangandanyuanyingwenming"
          width="150"
        ></el-table-column>
        <el-table-column
          prop="pinyincode"
          :label="dataobjs.pinyinma"
        ></el-table-column>
        <el-table-column
          prop="unitcode"
          :label="dataobjs.shibiema"
        ></el-table-column>
        <el-table-column
          prop="unit"
          :label="dataobjs.shuzhidanwei"
        ></el-table-column>
        <el-table-column
          prop="scale"
          :label="dataobjs.huansuanxishu"
        ></el-table-column>
        <el-table-column
          prop="bytes"
          :label="dataobjs.zijieshu"
        ></el-table-column>
        <el-table-column
          prop="decimaldigit"
          :label="dataobjs.xiaoshuweishu"
        ></el-table-column>
               <el-table-column
          prop="unit_en"
          :label="dataobjs.yingwendanwei"
        ></el-table-column>
        <el-table-column
          prop="upperlimit"
          :label="dataobjs.shangxian"
        ></el-table-column>
        <el-table-column
          prop="lowerlimit"
          :label="dataobjs.xiaxian"
        ></el-table-column>
        <el-table-column :label="dataobjs.shifoubuma">
          <template slot-scope="{ row }">{{
            row.iscomplement == true ? "是" : "否"
          }}</template>
        </el-table-column>

         <el-table-column label="图标" align="center">
          <template slot-scope="{ row }">
            <!-- <img :src="row.icon"  alt=""> -->
            <el-popover placement="top-start" title="" trigger="hover">
              <img :src="row.icon" alt="" style="width: 150px;height: 150px;    background: red;" >
            
              <img slot="reference" :src="row.icon" style="width: 50px;height: 50px;    background: red;" v-if="row.icon">
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column :label="dataobjs.caozuo" align="center" width="200">
          <template slot-scope="{ row }">
            <el-button
              size="mini"
              @click="editFrom(row)"
              round
              icon="el-icon-edit"
              type="primary"
              >{{ dataobjs.xiugai }}</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="deleData(row)"
              icon="el-icon-delete"
              round
              >{{ dataobjs.shanchu }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <page-helper
        :page-data="pageData"
        :total="total"
        :get-table-list="listCgDy"
      ></page-helper>
    </div>
    <!-- 添加要素 -->
    <el-dialog
      :title="title"
      :visible.sync="dialogVisibleAdd"
      :modal="false"
      width="45%"
      :close-on-click-modal="false"
      :before-close="handleClose"
    >
      <add
        :flile-imge="flileImge"
        :diohide="diohide"
        :rule-form="ruleForm"
        ref="fromList"
        :listcgdy="listCgDy"
        :dataobjs="dataobjs"
      />
    </el-dialog>
  </div>
</template>
<script>
import PageHelper from "@/components/common/PageHelper";
import add from "./components/add";
import { listCgDy, dealerDelete, lang_fend } from "@/network/index";
export default {
  components: {
    PageHelper,
    add,
  },
  data() {
    return {
      title: "",
      Delectloading: false,
      lang_file: sessionStorage.getItem("lang_file"),
      textContent: "正在努力加载中...",
      ruleForm: {
        unittype: "", //传感单元类型
        unittype_en: "", //传感单元类型英文名称
        unitcode: "", //传感单元识别码
        unit: "", //数值单位
        scale: "", //换算系数
        bytes: "", //字节数
        decimaldigit:0, //显示小数位数
        upperlimit: "", //上限值
        lowerlimit: "", //下线
        iscomplement: "0", //是否补码
        pinyincode: "", //简称
        icon: "",
        unit_en:''
      },
      dialogVisibleAdd: false,
      dialogVisible: true,
      input3: "",
      tableData: [],
      pageData: {
        pagenum: 1, //页码  pagenum  2
        pagesize: 30, //数据   pagesize几条数据
      },
      total: null,
      dataobjs: {},
      heithTs: null,
      flileImge: [],
    };
  },
  mounted() {
    // console.log(document.body.clientHeight - 300)
    this.heithTs = document.body.clientHeight - 150;
    this.listCgDy();
    this.lang_fend();
    // console.log(document.body.scrollHeight)
  },
  methods: {
    // 翻译
    async lang_fend() {
      let page = "sensingunit_page";
      let objs = {
        page,
        lang_file: this.lang_file,
      };
      const { data, code } = await lang_fend(objs);

      this.dataobjs = data;
    },
    tableRowClassName({ row, rowIndex }) {
      let index = rowIndex + 1;
      if (index % 2 == 0) {
        return "warning-row";
      } else {
        return "success-row";
      }
    },
    //情况表单
    handleClose() {
      this.ruleForm = {
       unittype: "", //传感单元类型
        unittype_en: "", //传感单元类型英文名称
        unitcode: "", //传感单元识别码
        unit: "", //数值单位
        scale: "", //换算系数
        bytes: "2", //字节数
        decimaldigit: "", //显示小数位数
        upperlimit: "", //上限值
        lowerlimit: "", //下线
        iscomplement: "0", //是否补码
        pinyincode: "", //简称
        icon: "",
        unit_en:''
      };
      this.dialogVisibleAdd = false;
      // this.$refs.fromList.dialogVisible()
    },
    // 获取传感单元列表
    async listCgDy() {
      this.Delectloading = true;
      let pagenum = this.pageData.pagenum; //页码
      let pagesize = this.pageData.pagesize; //多少条数据
      const res = await listCgDy(pagenum, pagesize);
      this.tableData = res.data.list;
      this.total = Number(res.data.pagelist[0].allrow);
      this.Delectloading = false;
    },
    //新增
    addClick() {
      this.flileImge = [];
      this.title = this.dataobjs.xinzengchuangandanyuan;
      this.dialogVisibleAdd = true;
      // console.log(this.flileImge);
      this.$nextTick(()=>{
            this.$refs.fromList.addimgLint()
      })
      
    },
    // 修改
    editFrom(row) {
      // console.log(row.icon);
      this.flileImge = [];
      if (row.icon != null) {
        this.flileImge.push({
          url: row.icon,
        });

        this.$nextTick(() => {
          this.$refs.fromList.hideLimg();
        });
      }else{
              this.$nextTick(() => {
          this.$refs.fromList.showLimg();
        });
      }

      this.title = this.dataobjs.xiugaichuangandanyuan;
      this.ruleForm = {...row};
      this.dialogVisibleAdd = true;

    },
    // 关闭子组件的方法
    diohide() {
      this.dialogVisibleAdd = false;
      this.ruleForm = {
       unittype: "", //传感单元类型
        unittype_en: "", //传感单元类型英文名称
        unitcode: "", //传感单元识别码
        unit: "", //数值单位
        scale: "", //换算系数
        bytes: "", //字节数
        decimaldigit: "", //显示小数位数
        upperlimit: "", //上限值
        lowerlimit: "", //下线
        iscomplement: "0", //是否补码
        pinyincode: "", //简称
        icon: "",
        unit_en:''
      };
    },
    //删除
    deleData(e) {
      console.log(e)
       this.$confirm(`${this.dataobjs.tishixinxi}`, `${this.dataobjs.tishi}`, {
        confirmButtonText: `${this.dataobjs.queding}`,
        cancelButtonText: `${this.dataobjs.quxiao}`,
        closeOnClickModal: false,
        type: "warning",
      })
        .then(async () => {
          let tablename = "tb_sensingunit";
          const { code, msg } = await dealerDelete(e.uuid, tablename);
          console.log(msg);
          if (code) {
            this.$message({
              type: "success",
             message:`${this.dataobjs.shanchuchenggong}`,
            });
            this.listCgDy();
          } else {
            this.$message.error(msg);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
             message: msg,
          });
        });
    },
  },
};
</script>
<style scoped>
.el-form-item {
  margin-bottom: 20px !important;
}
.soll_warp {
  height: 100%;
  overflow: auto;
  /* background: red; */
  /* padding-bottom: 150px; */
}
.scrole {
  /* height: 100%; */
  overflow: auto;
  width: 40%;
  /* padding: 20px; */
  display: flex;
}
.scrole input {
  /* width:40%; */
  padding: 20px !important ;
}
.tablesList {
  /* height: 500px; */
  height: 90%;
  overflow: auot;
}
.el-button {
  /* padding: 2px 20px !important ; */
}
</style>

